import { z } from 'zod'

z.setErrorMap((issue, ctx) => {
  if (issue.code === 'invalid_type' && issue.received === 'undefined') {
    return { message: 'Este campo é obrigatório' }
  }
  return { message: ctx.defaultError }
})

export const roomsSchema = z.object({
  nome: z.string().default(''),
  numero: z.string().optional(),
  capacidade: z.number().optional(),
  recursos: z.string().optional(),
  disponibilidade: z.boolean(),
  observacao: z.string().optional()
})

export type RoomsFormData = z.infer<typeof roomsSchema>
